import React from "react";

class TabsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  setActiveTab(index) {
    this.setState({ activeTab: index });
  }

  render() {
    const { tabLabels, tabContents } = this.props;
    const { activeTab } = this.state;

    const tabItems = tabLabels.map((tab, index) => {
      const id = activeTab == index ? "TabItem-Active" : "TabItem";
      return (
        <th key={index} id={id} onClick={() => this.setActiveTab(index)}>
          {tab}
        </th>
      );
    });

    const content = tabContents[activeTab];

    return (
      <div className="TabsPanel">
        <div className="TabsPanelHead">
          <table>
            <tbody>
              <tr className="TabItemWrap">{tabItems}</tr>
            </tbody>
          </table>
        </div>
        <div className="TabsPanelContent">{content}</div>
      </div>
    );
  }
}

export default TabsPanel;



// WEBPACK FOOTER //
// ./src/components/TabsPanel.js